
import {mapState} from 'vuex';
import dayjs from 'dayjs';

export const BookingFormatMixin = 
{ 
    computed: {
        ...mapState({
            BOOKING_STATUS: state => state.codeDictionary.items.BOOKING_STATUS,
            BOOKING_TYPE: state => state.codeDictionary.items.BOOKING_TYPE,
            BOOKING_CHOICE: state => state.codeDictionary.items.BOOKING_CHOICE,
        }),
    },
    methods: {
        bookingTitle(status) 
        {
            let bookingStatus = Object.values(this.BOOKING_STATUS).find(e => e.id == status);
            return (bookingStatus) ? bookingStatus.content : '';
        },

        bookingType(type)
        {
            let bookingType = Object.values(this.BOOKING_TYPE).find(e => e.id == type);
            return (bookingType) ? bookingType.content : '';
        },

        bookingChoice(score)
        {
            let bookingChoice = Object.values(this.BOOKING_CHOICE).find(e => e.id == score);
            return (bookingChoice) ? bookingChoice.title : '';
        },

        bookingDate(bookingDt) 
        {
            return dayjs(bookingDt).format("YYYY.MM.DD");
        },

        bookingTime(bookingDt) 
        {
            return dayjs(bookingDt).format("hh:mm A");
        },

        bookingAdminMemo(status, adminMemo) 
        {
            let memo = '';
            switch (status) {
                case this.BOOKING_STATUS.WAIT.id: memo = '전시장 담당자가 예약을 확인하고 있습니다.'; break;
                case this.BOOKING_STATUS.CHANGE.id: memo = adminMemo; break;
                case this.BOOKING_STATUS.CONFIRMED.id: memo = '전시장 방문 예약이 확정되었습니다. 즐거운 방문이 될 수 있도록 최선을 다하겠습니다.'; break;
                case this.BOOKING_STATUS.CANCEL.id: memo = '예약이 취소되었습니다.'; break;
            }
            return memo;
        },
    },
};